import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';


function BankIndex() {
    const history = useHistory();

    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);


    const hasCreateMasterPermission = permissions.includes('Create Bank');
    const hasEditMasterPermission = permissions.includes('Edit Bank');
    const hasDeleteMasterPermission = permissions.includes('Delete Bank');

    useEffect(() => {

        fetchtableData();

    }, []);


    const fetchtableData = async () => {

        fetchData('Bank', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Route Details:', error);
            });


    };



    const handleDelete = async () => {
        deleteData('Bank', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });

    };

    const handleActivate = (bankId) => {
        activateData('Bank', `${bankId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
            })
            .catch((error) => {
                // Handle errors for the activation request
            });
    };

    const openConfirmDialog = (bankId) => {
        setDeleteItemId(bankId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const handleCreateNewClick = (page) => {
        history.push(`/${page}`);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }
  // Define initial column order
    const [columnOrder, setColumnOrder] = useState([

        'Bank',
       
        'Account No',
        'Branch',
        'UPI ID',
        'Opening Balance',
        ...(hasCreateMasterPermission ? ['Action'] : [''])

    ]);
    return (
        <div className="w-full max-w-sm container mt-6" style={{ maxWidth: '90%' }}>
            <div className='w-full mb-1 flex' style={{ marginTop: '-10px', marginLeft: '10px' }}>
                <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    Bank</h6>
                {hasCreateMasterPermission && (
                    <Tooltip title="Create Route">
                        <Link to="/BankCreate" className="inline-block">
                            <Button
                                style={{
                                    background: 'linear-gradient(to right, darkslategray, slategray)',
                                    borderRadius: '50px',
                                    padding: '10px 20px',
                                    color: 'white',
                                    fontWeight: 'bolder',
                                    textTransform: 'none',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                    maxHeight: '35px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <AddIcon style={{ fontWeight: 'bolder' }} /> Create
                            </Button>
                        </Link>
                    </Tooltip>
                )}
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>

                {/* <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#0B5345' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', width: '15%' }}>Bank</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }}>Account No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }}>Branch</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }}>UPI ID</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', textAlign: 'center' }}>Opening Balance</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', textAlign: 'right' }}>Action</TableCell>
                            </TableRow>
                        </TableHead> */}
                         <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{
                            backgroundColor: 'teal',
                            position: 'sticky',
                            top: 0,
                            zIndex: 1, width: '2000px'
                        }}>
                            <TableRow>
                                {columnOrder.map((col, index) => (
                                    <TableCell
                                        key={index}
                                        style={{
                                            padding: '6px',
                                            cursor: 'move',
                                            color: 'white',
                                            fontWeight: 'bold',

                                        }}

                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        {/* <TableBody style={{ backgroundColor: 'white' }}>
                            {data.map(item => (
                                <TableRow key={item.Id} className={item.IsActive ? 'activeRow' : 'inactiveRow'}>
                                    <TableCell style={{ borderBottom: '1px solid #FFE1E2', color: 'black', padding: '5px', width: '15%' }}>{item.BankName}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #FFE1E2', color: 'black', padding: '5px', width: '20px' }}>{item.AccountNo}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #FFE1E2', color: 'black', padding: '5px', width: '20px' }}>{item.Branch}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #FFE1E2', color: 'black', padding: '5px', width: '20px' }}>{item.UPINo}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #FFE1E2', color: 'black', padding: '5px', width: '20px', textAlign: 'right' }}>{item.OpeningBalance.toFixed(2)}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #FFE1E2', color: 'black', textAlign: 'right', padding: '5px', width: '50px' }}>
                                        {hasEditBank && (
                                            <Link to={`/BankEdit/${item.Id}`}>
                                                <Tooltip title="Bank Route">
                                                    <IconButton>
                                                        <EditIcon style={{ color: 'darkgoldenrod' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Link>
                                        )}
                                        {hasDeleteBank && (

                                            <Tooltip >
                                                <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                                                    {item.IsActive ? <DeleteIcon style={{ color: 'brown' }} /> : <ActivateIcon />}
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody> */}
                         <TableBody>
                            {Array.isArray(data) && data.length > 0 ? (
                                data.map((rowData, index) => {
                                    const rowValues = {
                                        'Bank':rowData.BankName,
                                        'Account No':rowData.AccountNo,
                                        'Branch':rowData.Branch,
                                        'UPI ID':rowData.UPINo,
                                        'Opening Balance':rowData.OpeningBalance.toFixed(2),
                                        'Action': (
                                            <>
                                                {hasEditMasterPermission && (
                                                   <Link to={`/BankEdit/${rowData.Id}`}>
                                                <Tooltip title="Edit bank">
                                                            <IconButton>
                                                                <EditIcon style={{ color: 'darkgoldenrod' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Link>
                                                )}

                                                {hasDeleteMasterPermission && (
                                                    <Tooltip title={rowData.isActive ? 'Delete Bank' : 'Activate Bank'}>
                                                        <IconButton
                                                            onClick={() =>
                                                                rowData.isActive
                                                                    ? openConfirmDialog(rowData.Id)
                                                                    : handleActivate(rowData.Id)
                                                            }
                                                        >
                                                            {rowData.isActive ? (
                                                                <DeleteIcon style={{ color: 'brown' }} />
                                                            ) : (
                                                                <ActivateIcon />
                                                            )}
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </>
                                        ),
                                    };

                                    return (
                                        <TableRow key={index}>
                                            {Object.keys(rowValues).map((key) => (
                                                <TableCell
                                                    key={key}
                                                    sx={{
                                                        fontSize: '14px',
                                                        padding: '5px',
                                                        textAlign: 'left',
                                                        width: '20px',
                                                    }}
                                                >
                                                    {rowValues[key]}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={6} sx={{ textAlign: 'center' }}>
                                        No data available.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        {/* Delete confirmation dialog */}
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default BankIndex;

